<template>
  <ion-page id="main-content" class="page">
    <desktop-header
      v-if="isDesktop && !hideDesktopHeader"
      :is-search-available="isSearchAvailable"
    />
    <slot name="header"></slot>
    <ion-content
      :class="{'main-content--light': light}"
      class="main-content"
    >
      <slot></slot>
    </ion-content>
    <sidebar-component/>
  </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonPage } from "@ionic/vue";
import SidebarComponent from "@/modules/General/components/SidebarComponent.vue";
import DesktopHeader from "@/modules/General/components/DesktopHeader.vue";
import {useBreakpoint} from "@/hooks/useBreakpoint";

defineProps<{
  light?: boolean;
  hideDesktopHeader?: boolean;
  isSearchAvailable?: boolean;
}>();

const { isDesktop } = useBreakpoint();

</script>

<style lang="scss" scoped>
.menu-content-open {
  pointer-events: auto;
  cursor: default;
}

.main-content{
  --padding-top: 20px;
  &--light {
    --ion-background-color: var(--ion-color-white);
  }
  @media screen and (min-width: 1024px) {
    --padding-top: 0;
    height: auto;
    border-radius: 10px;
    contain: initial;
    width: calc(100% - 32px);
    position: relative;
    left: 16px;
    right: 16px;
  }

}

.page {
  @media screen and (min-width: 1024px) {
    padding-top: 40px;
    padding-left: 325px;
    padding-right: 40px;
    padding-bottom: 20px;
    display: block;
    contain: initial;
    overflow-y: auto;

    &.withStepsBar:deep(.main-content) {
      top: 20px;
    }
  }
}
</style>